import FlipCountdown from 'vue2-flip-countdown'
import blurbForConference from '@/components/public/video-conference/blurb-for-conference-popup';
import{ bus } from '@/main';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';

/*eslint-disable */


// import userInfo from './user-info-for-conference';
var $ = window.jQuery = require('jquery');
export default {
  name: 'jascap-webinar-promotion-page',
  components: {
    'blurb-for-conference' : blurbForConference,
    FlipCountdown 
  },
  props: [],
  data () {
    return {
      userInfoStoreState:false,
      timeElapsedState:true,
      presentDate: new Date(),
      getPublicVistaMeetingData:null,
      blurTextbPopupState:false
    }
  },
  computed: {
    ...mapGetters([
      'getPublicVistaMeetingGetters',
    ]),
    getPublicVistaMeetingMethod(){
      this.getPublicVistaMeetingData = this.$store.getters.getPublicVistaMeetingGetters.data
      return
    },
  },
  mounted () {
    bus.$on('userInfoStoreBus', (data) => {
      this.userInfoStoreState = data;
    });
    bus.$on('blurTextbPopupStateBus', (data) => {
      this.blurTextbPopupState = data;
    });
    this.checkDateAndTimeMethod()
  },
  methods: {
    blurbTextPopupOpen(){
      this.blurTextbPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    checkDateAndTimeMethod(){
      if(moment().format('MM-DD-YYYY') >= '10-31-2021' && moment().format('HH:mm:ss') >= '11:00:00'){
        this.timeElapsedState = false
      }else{
        this.timeElapsedState = true
      }
    },
    timeElapsedHandler () {
      this.timeElapsedState = false
    },
    discoverNowMethod(){
      this.userInfoStoreState = true
      $('body').addClass('body_right_scroll_remove')
    }
  },
  watch:{
    getPublicVistaMeetingMethod(){
      return this.$store.getters.getPublicVistaMeetingGetters
    },
  },
  beforeCreate: function() {
    $('body').addClass('lbil_launched_conference_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('lbil_launched_conference_wrp')
    next();
  },
}